/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_Save_SettingsInputs */

const en_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Settings`)
};

const fr_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les paramètres`)
};

const de_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen speichern`)
};

const it_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva impostazioni`)
};

const ru_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраните настройки`)
};

const es_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar configuración`)
};

const zh_cn2_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存设置`)
};

const ja_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を保存`)
};

const hi_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स सेव करें`)
};

const pt_pt2_options_integrations_save_settings = /** @type {(inputs: Options_Integrations_Save_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar configurações`)
};

/**
* | output |
* | --- |
* | "Save Settings" |
*
* @param {Options_Integrations_Save_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_save_settings = /** @type {((inputs?: Options_Integrations_Save_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_Save_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_integrations_save_settings(inputs)
	if (locale === "de") return de_options_integrations_save_settings(inputs)
	if (locale === "it") return it_options_integrations_save_settings(inputs)
	if (locale === "ru") return ru_options_integrations_save_settings(inputs)
	if (locale === "es") return es_options_integrations_save_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_options_integrations_save_settings(inputs)
	if (locale === "ja") return ja_options_integrations_save_settings(inputs)
	if (locale === "hi") return hi_options_integrations_save_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_options_integrations_save_settings(inputs)
	return en_options_integrations_save_settings(inputs)
});